import styled, { css } from 'styled-components'

export const FromSelectStyled = styled.select`
  display: block;
  padding: 15px 35px 15px 15px;
  border: 2px solid ${({ theme, green }) => green ? theme.grassyGreen50 : theme.veryLightPink};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  color: ${({ theme }) => theme.greyishBrown};
  border-radius: 6px;
  transition: border .15s;
  width: 100%;
  -webkit-appearance: none;
  background: none;
  ::placeholder {
    color: ${({ theme }) => theme.lightPeach};
  }
`

export const FromSelectError = styled.div`
  color: ${({ theme }) => theme.pastelRed};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: 5px;
  margin-bottom: 5px;
  height: 15px;
  opacity: 0;
  transition: opacity .15s;
`

export const FromSelectLabelWrapper = styled.label`
  display: block;
  position: relative;
  margin-bottom: 20px;
  &:before {
    content: '';
    width: 10px;
    height: 10px;
    position: absolute;
    bottom: 22px;
    right: 15px;
    border-right: 1.5px solid ${({ theme }) => theme.brownGrey};
    border-bottom: 1.5px solid ${({ theme }) => theme.brownGrey};
    transform: rotate(45deg);
    pointer-events: none;
  }
  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0;
    `
  }
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${({ maxWidth }) => maxWidth ? maxWidth : 'auto'}
    `
  }
  ${({ error }) =>
    error &&
    css`
      ${FromSelectStyled} {
        border: 2px solid ${({ theme }) => theme.pastelRed};
      }
      ${FromSelectError} {
        opacity: 1;
      }
    `
  }
${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `
  }
`

export const FromSelectLabel = styled.div`
  margin-bottom: 10px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.greyishBrown};
`